  document.addEventListener('DOMContentLoaded', () => {
    class DetailsAccordion {
      constructor(el) {
        this.el = el;
        this.summary = el.querySelector('summary');
        this.content = el.querySelector('.section-search__tab-content');
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;

        this.summary.addEventListener('click', (e) => this.onClick(e));
      }

      onClick(e) {
        // PC（641px以上）はネイティブの挙動（CSSグリッド連動）に任せる
        if (window.innerWidth > 640) return;

        e.preventDefault();
        this.el.style.overflow = 'hidden';

        if (this.isClosing || !this.el.open) {
          this.open();

          // name属性による排他制御（他の開いているアコーディオンをアニメーション付きで閉じる）
          const name = this.el.getAttribute('name');
          if (name) {
            document.querySelectorAll(`details[name="${name}"]`).forEach((other) => {
              if (other !== this.el && other.open) {
                other.querySelector('summary').click();
              }
            });
          }
        } else if (this.isExpanding || this.el.open) {
          this.shrink();
        }
      }

      shrink() {
        this.isClosing = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;

        if (this.animation) this.animation.cancel();

        this.animation = this.el.animate({ height: [startHeight, endHeight] }, {
          duration: 300,
          easing: 'ease-out'
        });

        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => this.isClosing = false;
      }

      open() {
        this.el.style.height = `${this.el.offsetHeight}px`;
        this.el.open = true;
        window.requestAnimationFrame(() => this.expand());
      }

      expand() {
        this.isExpanding = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

        if (this.animation) this.animation.cancel();

        this.animation = this.el.animate({ height: [startHeight, endHeight] }, {
          duration: 300,
          easing: 'ease-out'
        });

        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => this.isExpanding = false;
      }

      onAnimationFinish(open) {
        this.el.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.el.style.height = this.el.style.overflow = '';
      }
    }

    document.querySelectorAll('.section-search__tabs details').forEach(el => new DetailsAccordion(el));
  });
